import TrackPageView from "../utilities/TrackPageView";
import { ProgramContainer } from "../entities/formTemplateDataType";
import { getCleansedUrl, normalizeUrl } from "../utilities/URLUtils";
import { AbstractPageRedirectHandler } from "./AbstractPageRedirectHandler";

export enum PaymentResponseAttributes {
    StatusCode = 'statusCode',
    OrderTransactionId = 'orderTransactionId',
    TransactionId = 'transactionId',
  }

 /**
  * To handle page-redirection related requests in PLP.
  */
export class PlpPageRedirectHandler implements AbstractPageRedirectHandler {
  constructor() {}
  programContainer: ProgramContainer;

  isRedirectionRequired(): boolean {
    console.log('about to execute isRedirectionRequired in PlpPageRedirectHandler...');
    const clonedUrl = new URL(window.location.href);
    const approvalStatus = clonedUrl.searchParams?.get(PaymentResponseAttributes.StatusCode);

		return (!!approvalStatus);
  }

  isProcessSuccessful(): boolean {
    console.log('about to execute isProcessSuccessful in PlpPageRedirectHandler...');
    const cleansedUrl = new URL(getCleansedUrl(window.location.href));
    const statusCode = cleansedUrl.searchParams?.get(PaymentResponseAttributes.StatusCode);
    const transactionId = cleansedUrl.searchParams?.get(PaymentResponseAttributes.TransactionId);
    const processSuccess = (statusCode === '001') && (!!transactionId);
    const originalUrl = new URL(window.location.href);
    this.setRedirectSearchParams(originalUrl, processSuccess, statusCode, transactionId);

		return processSuccess;
  }

  getTransactionStatus(): string {
    console.log('about to execute getTransactionStatus in PlpPageRedirectHandler...');
    const cleansedUrl = new URL(getCleansedUrl(window.location.href));
    return cleansedUrl.searchParams?.get(PaymentResponseAttributes.StatusCode);
  }

  getOrderTransactionId(): string {
    console.log('about to execute getOrderTransactionId in PlpPageRedirectHandler...');
    const cleansedUrl = new URL(getCleansedUrl(window.location.href));
    return cleansedUrl.searchParams?.get(PaymentResponseAttributes.OrderTransactionId);
  }

  getTransactionId(): string {
    console.log('about to execute getTransactionId in PlpPageRedirectHandler...');
    const cleansedUrl = new URL(getCleansedUrl(window.location.href));
    return cleansedUrl.searchParams?.get(PaymentResponseAttributes.TransactionId);
  }

  getPageForSuccessfulProcess(): number {
    return 8;
  }

  getPageForUnsuccessfulProcess(): number {
    return 7;
  }

  getErrorMessageForUnsuccessfulProcess(language: string): string {
    return language !== 'fr' ? 'Please select a different payment method or try again.' : 'Veuillez sélectionner un autre mode de paiement ou réessayer.';
  }

  populateApiRequest(programContainer: ProgramContainer): void {
    this.programContainer = programContainer;
    const transactionStatusElement = this.findFieldByName(programContainer, 'paymentStatus');
    const orderTransactionIdElement = this.findFieldByName(programContainer, 'paymentOrderTransactionId');
    const transactionIdElement = this.findFieldByName(programContainer, 'paymentTransactionId');

    transactionStatusElement.Value = this.getTransactionStatus() === '001' ? 'success' : 'failure';
    if (orderTransactionIdElement) {
      orderTransactionIdElement.Value = this.getOrderTransactionId();
    }
    transactionIdElement.Value = this.getTransactionId();
  }

  findFieldByName = (programContainer: ProgramContainer, fieldName: string) => {
    this.programContainer = programContainer; 
    const formList = programContainer.ListOfFormSections;
    let eleReturned;
    try {
      formList.forEach(section => {
        if (section.Visible == false) return;
        section.ListOfFormSubSections.forEach(sub => {
          const elements = sub.ListOfFormSectionElements;
          elements.forEach(ele => {
            if (ele.LoadBindName == fieldName) {
              eleReturned = ele;
              throw new Error('Exit all loops');
            }
          })
        })
      });
    } catch {
      return eleReturned;
    }
    return null;
  }

  /**
   * Removing all the original query parameters from the URL, and could insert specific ones for the redirecting page.
   */
  private setRedirectSearchParams(url: URL, processSuccess: boolean, status?: string, transactionId?: string) {
    if (!processSuccess) {
      url.href = url.href + '&paymentError=Y';
      history.replaceState({}, '', normalizeUrl(url.toString()));  // Update the URL.

      if (this.programContainer) {
        TrackPageView(this.programContainer);
      }
    }
  }
}